import { render, staticRenderFns } from "./RegPage.vue?vue&type=template&id=257e9582"
import script from "./RegPage.vue?vue&type=script&lang=js"
export * from "./RegPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports